import * as React from 'react';
import {emotionStyled} from '@packages/utilities/styled';
import {Icon} from '../Icon';
import {InputWrapper} from './InputWrapper';
import {InputAddon} from './InputAddon';
import {useInput} from './useInput';
import {type InputProps} from './Input.types';

const BaseInputView = emotionStyled('input')(
  {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    borderRadius: '$2',
    borderStyle: 'solid',
    borderWidth: 0,
    boxSizing: 'border-box',
    color: '$textPrimary',
    cursor: 'auto',
    display: 'block',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    height: '100%',
    lineHeight: 1,
    outline: '2px solid transparent',
    padding: '0 $1',
    width: '100%',
    '&::placeholder': {
      color: '$textDimmed',
    },
  },
  {
    variants: {
      disabled: {
        true: {
          cursor: 'not-allowed',
          color: '$textDimmed',
          WebkitTextFillColor: '$textDimmed',
          '&::placeholder': {
            color: '$textDimmed',
          },
        },
      },
    },
  }
);

/**
 * @deprecated use `TextInput` from `@packages/systems/spring` instead
 */
export const Input = React.forwardRef<any, InputProps>((props, ref) => {
  const {
    disabled,
    paddingLeft,
    paddingRight,
    wrapperProps,
    prefix,
    suffix,
    style = {},
    ...rest
  } = useInput(props);

  /**
   * @todo Seriously examine the implementation of Prefix/Suffix.
   * Keeping this around to support older implementations. However, I'm unsure
   * if it's actual use-case is ideal, for example:
   *
   * shared/render/plugins/Embed/VideoPluginType.jsx
   *
   * 2021-09-01
   */
  const prefixMarkup = prefix ? (
    <InputAddon>
      {typeof prefix === 'string' ? prefix : <Icon glyph={prefix} />}
    </InputAddon>
  ) : null;

  const suffixMarkup = suffix ? (
    <InputAddon>
      {typeof suffix === 'string' ? suffix : <Icon glyph={suffix} />}
    </InputAddon>
  ) : null;

  return (
    <InputWrapper {...wrapperProps} ref={ref}>
      {prefixMarkup}
      <BaseInputView
        {...rest}
        disabled={disabled}
        style={{...style, paddingLeft, paddingRight}}
      />
      {suffixMarkup}
    </InputWrapper>
  );
});

export default Input;
